
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRoute as ObiRouteElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-route.js';
 
 
 

 
 export const ObiRoute = createComponent({
   react: React,
   tagName: 'obi-route',
   elementClass: ObiRouteElement,
   events: {
     
   }
  });
 
 